import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import { Header, Footer, Sidebar } from "components";

import dashboardRoutes from "routes/dashboard.jsx";
import Bills from "views/Bills/BillsGlobalStatus.jsx";
import BillsReturned from "views/Bills/BillsReturned.jsx";
import BillsReturnedList from "views/Bills/BillsReturnedList.jsx";
import BillsProviders from "views/Bills/BillsProviders.jsx";
import BillDetail from "views/Bills/BillDetail.jsx";
import Customers from "views/Customers/CustomersList.jsx";
import CustomerProfile from "views/Customers/CustomerProfile.jsx";
import CustomerMobile from "views/Customers/CustomerMobile.jsx";
import CustomerMobileRegistries from "views/Customers/CustomerMobileRegistries.jsx";
import Mobiles from "views/Mobiles/MobilesList.jsx";
import MobileDetail from "views/Mobiles/MobileDetail.jsx";
import DashboardPanel from "views/Dashboard/Dashboard.jsx";
import Configuration from "views/Configuration/Configuration.jsx";
import Notifications from "views/Notifications/Notifications.jsx";
import MobileProcedure from "views/MobileProcedures/MobileProceduresList.jsx";
import CustomerWizard from "views/Customers/CustomerWizard/CustomerWizard.jsx";
import MobileRequest from "views/Web/MobileWebRequestList.jsx";
import NewContract from "../../views/Contracts/NewContract";
import ContractsList from "../../views/Contracts/ContractsList";
import ViewContract from "../../views/Contracts/ViewContract";
import EditContract from "../../views/Contracts/EditContract";
import Pegasus from "views/Pegasus/Pegasus";
import Cajas from "views/CashRegisters/CashRegistersList.jsx";
import CajaDetalle from "views/CashRegisters/CashRegisterDetail.jsx";
import HomeVisitsList from "views/HomeVisits/HomeVisitsList.jsx";
import ViewHomeVisit from "views/HomeVisits/ViewHomeVisit.jsx";
import NewHomeVisit from "views/HomeVisits/NewHomeVisit.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
import Tools from "views/Tools/Tools.jsx";
import Tickets from "views/Tickets/Tickets.jsx";
import ViewTicket from "views/Tickets/ViewTicket.jsx";
import NewTicket from "views/Tickets/NewTicket.jsx";
import Coverage from "views/Coverage/Coverage.jsx";
import Tasks from "views/Tasks/Tasks.jsx";
import WebContent from "views/Web/WebContent.jsx";
import WebContentDetails from "views/Web/WebContentDetails.jsx";
import Roulette from "views/Roulette/Roulette.jsx";
import RouletteDashboard from "views/Roulette/RouletteDashboard.jsx";
import RouletteResults from "views/Roulette/RouletteResults.jsx";
import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
import Schedule from "views/Schedule/Schedule.jsx";
import ShiftTemplate from "views/ShiftTemplate/ShiftTemplate.jsx";
import CheckersList from "views/CheckIn/CheckersList.jsx";
import CheckinList from "views/CheckIn/CheckinList.jsx";
import CheckinListAll from "views/CheckIn/CheckinListAll.jsx";
import CheckinListToday from "views/CheckIn/CheckinListToday.jsx";
// import FaceDetectionTest from "../../views/FaceDetection/FaceDetectionTest";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    //this.startLogin = this.startLogin.bind(this);
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.refs.mainPanel);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
    // console.log("####  TEST DIDUPDATE ####");
    // console.log(e);
    // window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="wrapper">
        {!window.location.pathname.includes("/aprender") && <Sidebar {...this.props} routes={dashboardRoutes}/>}
        <div className={"main-panel" + (window.location.pathname.includes("/aprender")? " aprender": "")} ref="mainPanel">
        {!window.location.pathname.includes("/aprender") && <Header {...this.props} signOut={this.props.signOut} />}
          <Switch>
            <Route
              exact
              path="/inicio"
              render={props =>
                <DashboardPanel {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/turnos"
              render={props =>
                <Schedule {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/turnos/plantillas"
              render={props =>
                <ShiftTemplate {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/cobertura"
              render={props =>
                <Coverage {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } />
            <Route
              exact
              path="/configuracion/cara"
              render={props =>
                <FaceDetection {...props} {...this.props} userData={this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/fichadores"
              render={props =>
                <CheckersList {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/fichajes"
              render={props =>
                <CheckinList {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/fichajes/hoy"
              render={props =>
                <CheckinListToday {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              exact
              path="/fichajes/todos"
              render={props =>
                <CheckinListAll {...props} {...this.props} mainState={this.props.mainState} />
              } />
            <Route
              // exact
              path="/aprender"
              render={props =>
                <FaceDetection {...props} {...this.props} userData={this.props} mainState={this.props.mainState} />
              } />
            {/* <Route
              exact
              path="/entrar/cara"
              render={props =>
                <FaceDetection {...props} {...this.props} userData={this.props} mainState={this.props.mainState} />
              } /> */}
            {/* <Route
              exact
              path="/facetest"
              render={props =>
                <FaceDetectionTest {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } /> */}
            <Route
              exact
              path="/configuracion"
              render={props =>
                <Configuration {...props} {...this.props} userData={this.props} mainState={this.props.mainState} loadInternet={this.props.loadInternet}/>
              } />
            <Route
              exact
              path="/notificaciones"
              render={props =>
                <Notifications {...this.props}/>
              } />
            <Route
              exact
              path="/calendario"
              render={props =>
                <Calendar
                  {...props}
                  {...this.props}
                  userData={this.props}
                  mainState={this.props.mainState}
                  saveSessionConfig={this.props.saveSessionConfig}
                />
              } />
            <Route
              exact
              path="/clientes"
              render={props =>
                <Customers
                  {...props}
                  setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                  searchCustomer={this.props.searchCustomer}
                  userData={this.props}
                  mainState={this.props.mainState}
                  showNotification={this.props.showNotification}
                />
              } />
              <Route
                exact
                path="/tramites"
                render={props =>
                  <MobileProcedure
                    {...props}
                    setSearchCustomerQuery={this.props.setSearchCustomerQuery}
                    searchCustomer={this.props.searchCustomer}
                    userData={this.props}
                    mainState={this.props.mainState}
                    createMobileProcedure={this.props.createMobileProcedure}
                    searchMobileProcedures={this.props.searchMobileProcedures}
                    cancelMobileProcedure={this.props.cancelMobileProcedure}
                  />
                } />
              <Route
                exact
                path="/herramientas"
                render={props =>
                  <Tools {...props} 
                    userData={this.props} 
                    mainState={this.props.mainState} 
                    loadInternet={this.props.loadInternet}
                    confirmSIMDelivery={this.props.confirmSIMDelivery}
                    />
                } />
              <Route
                exact
                path="/herramientas/:tool"
                render={props =>
                  <Tools {...props} 
                    userData={this.props} 
                    mainState={this.props.mainState} 
                    loadInternet={this.props.loadInternet}
                    confirmSIMDelivery={this.props.confirmSIMDelivery}
                    />
                } />
            {dashboardRoutes.map((prop, key) => {
              if (prop.collapse) {
                return prop.views.map((prop2, key2) => {
                  return (
                    <Route
                      path={prop2.path}
                      component={prop2.component}
                      key={key2}
                    />
                  );
                });
              }
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          {// we don't want the Footer to be rendered on full screen maps page
          this.props.location.pathname.indexOf("full-screen-maps") !==
          -1 ? null : (
            <Footer fluid />
          )}
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx